module.exports = __webpack_public_path__ + "static/media/wmTrial-numbers-2.ff9d1645.mp3";